import moment from "moment";
import Config from "./Config";
import { PaymentMethods, SortOptions } from "./Constants";
import {
  EHeaderTemplateMenuOptions,
  ENoteType,
  EWhatsAppComponentsTypes,
  EWhatsAppMessageType,
  EWhatsAppTemplateButtonType,
  EWhatsAppTemplateCategory,
} from "./Enums";
import { Vocabulary } from "./Vocabulary";
import { v4 as uuidv4 } from "uuid";
import * as yup from "yup";

export class LoginModel {
  username: string | null = "";
  password: string | null = "";
}

export class UserModel {
  _id: string | null = null;
  lastName: string | null = "";
  firstName: string | null = "";
  workPoint_id: string | WorkPointModel | null = null;
  email: string | null = "";
  username: string | null = "";
  password: string | null = "";
  roleIds: RoleModel[] | null = [];
  gender: string | null = "";
  ciSerialNumber: string | null = "";
  ciNumber: string | null = "";
  ciIssuedBy: string | null = "";
  ciIssuedDate: string | null = "";
}

export class VehicleModel {
  _id: string | null = null;
  brand: string | null = "";
  model: string | null = "";
  modelDate: string | null = "";
  color: string | null = "";
  vehicleNumber: string | null = "";
  isActive: boolean | null = true;
  automata: boolean | null = false;
  document_ids: DocumentsModel[] | null = [];
  chassis: string | null = "";
  workPointId: string | WorkPointModel | null = null;
}

export class SubscriptionModel {
  _id: string | null = null;
  name: string | null = "";
  description: string | null = "";
  price: number | null = 0;
  durationInDays: number | null = 0;
  benefits: Array<{ name: string }> | null = [];
  isActive: boolean | null = true;
}

export class WorkPointModel {
  _id: string | null = null;
  name: string | null = "";
  email: string | null = "";
  phoneNumber: string | null = "";
  schoolName: string | null = "";
  serialNumber: string | null = "";
  oblioSerialNumber: string | null = "";
  number: string | null = "";
  administrator: string | null = "";
  director: string | null = "";
  visible: boolean | null = true;
  isMain: boolean | null = false;
  address: AddressModel | null = null;
  companyId: string | null = null;
}

export class CompanyModel {
  _id: string | null = null;
  CUI: string | null = "";
  name: string | null = "";
  email: string | null = "";
  phoneNumber: string | null = "";
  visible: boolean | null = true;
  address: AddressModel | null = null;
}

export class InstructorModel {
  _id: string | null = null;
  user_id: string | null | UserModel = "";
  vehicle_ids: string[] | null = [];
  document_ids: DocumentsModel[] | null = [];
  instructorId?: string | undefined = "";
}

export class ProductPriceModel {
  workPointId: string | null = null;
  price: string | null = "";
}

export class ProductsModel {
  _id: string | null = null;
  name: string | null = "";
  price: string | null = "";
  pricesByWorkPoint?: ProductPriceModel[] | null = [];
  isCertificate: boolean | null = false;
  documentTypes?: string[] | null = [];
}

export class MessageContextModal {
  id: string | null = null;
  from: string | null = "";
}

export class MessageImage {
  id: string | null = null;
  mime_type: string | null = "";
  sha256: string | null = "";
}

export class DocumentModel {
  id: string | null = null;
  filename: string | null = "";
  mime_type: string | null = "";
  sha256: string | null = "";
  caption: string | null = "";
}

export class MessageModel {
  id: string | null = null;
  message: any = "";
  sender: string | null = "";
  timestamp: string | Date = "";
  type: string | null = "";
  image: MessageImage | null = new MessageImage();
  document: DocumentModel | null = new DocumentModel();
  isUser: boolean | null = false;
  status = "";
  context: MessageContextModal | null = new MessageContextModal();
}

export class TVA {
  _id: string | null = null;
  name: string | null = "";
  value: string | null = "";
}

export class NoteModel {
  _id: string | null = uuidv4();
  type = ENoteType.OTHERS;
  text = "";
  client: ClientModel | null = null;
  agent: UserModel | null | string = null;
  visibility = false;
  address = new AddressModel();
  createdAt: string | null | Date = new Date();
}

export class OblioBillingDocument {
  type = "";
  issueDate: string | null = "";
  seriesName = "";
  number = "";
  link: string | null = "";
  edit: string | null = "";
  issuerName: string | null = "";
  products: OblioBillingProduct[] = [];
  status = "";
  hasBeenBilled: boolean | null = null;
  referenceDocument: ReferenceDocumentModel | null =
    new ReferenceDocumentModel();
}

export class OblioBillingProduct {
  name: string | null = "";
  price: number | null = null;
  quantity: number | null = null;
  vatPercentage: number | null = null;
  vatIncluded: boolean | null = null;
  productType: string | null = "Marfa";
}

export class ShippingModel {
  first_name: string | null = "";
  last_name: string | null = "";
  company: string | null = "";
  address_1: string | null = "";
  address_2: string | null = "";
  city: string | null = "";
  state: string | null = "";
  postcode: string | null = "";
  country: string | null = "";
}

export class BillingModel {
  first_name: string | null = "";
  last_name: string | null = "";
  company: string | null = "";
  address_1: string | null = "";
  address_2: string | null = "";
  city: string | null = "";
  state: string | null = "";
  postcode: string | null = "";
  country: string | null = "";
  email: string | null = "";
  phone: string | null = "";
}

export class OrderStatusModel {
  _id: string | null = null;
  name: string | null = "";
  slug: string | null = "";
  isDefault = false;
  color = "#FFF";
  sortNumber: number | null = null;
  typeId: string | OrderTypeModel | null = "";
}

export class OrderTypeModel {
  _id: string | null = null;
  name: string | null = "";
}

export class OrderSettingsModel {
  _id: string | null = null;
  name: string | null = "";
  translation: string | null = "";
  value: OrderValue | null = {
    currentOrderNumber: 0,
    paymentMethods: [],
    startOrderNumber: 0,
  };
}

export class TransportSettingsModel {
  isDefault: boolean | null = false;
  name: string | null = "";
  value: string | null = "";
}

export class OrderValue {
  currentOrderNumber: number | null = 0;
  paymentMethods: string[] | null = [];
  startOrderNumber: number | null = 0;
}

export class ProductDimensionsModel {
  length = "";
  width = "";
  height = "";
}

export class ProductModel {
  _id: string | null = null;
  wordPress_Id: string | null = null;
  name: string | null = "";
  slug: string | null = "";
  permalink = "";
  date_created: string | null = "";
  date_created_gmt: string | null = "";
  date_modified: string | null = "";
  date_modified_gmt: string | null = "";
  type: string | null = "";
  status: string | null = "";
  featured: boolean | null = null;
  catalog_visibility: string | null = "";
  description = "";
  short_description = "";
  sku: string | null = "";
  price = "";
  regular_price: string | null = "";
  sale_price: string | null = "";
  date_on_sale_from: string | null = "";
  date_on_sale_from_gmt: string | null = "";
  date_on_sale_to: string | null = "";
  date_on_sale_to_gmt: string | null = "";
  on_sale: boolean | null = null;
  purchasable: boolean | null = null;
  total_instructors: number | null = null;
  virtual: boolean | null = null;
  downloadable: boolean | null = null;
  downloads: any[] | null = [];
  download_limit: number | null = null;
  download_expiry: number | null = null;
  external_url: string | null = "";
  button_text: string | null = "";
  tax_status: string | null = "";
  manage_stock: boolean | null = null;
  stock_quantity: string | null = "";
  backorders: string | null = "";
  backorders_allowed: boolean | null = null;
  backordered: boolean | null = null;
  low_stock_amount: string | null = "";
  sold_individually: boolean | null = null;
  weight: string | null = "";
  dimensions: ProductDimensionsModel | null = new ProductDimensionsModel();
  shipping_required: boolean | null = null;
  shipping_taxable: boolean | null = null;
  shipping_class: string | null = "";
  shipping_class_id: string | null = "";
  reviews_allowed: boolean | null = null;
  average_rating: string | null = "";
  rating_count: number | null = null;
  upsell_ids: any[] | null = [];
  cross_sell_ids: any[] | null = [];
  parent_id: string | null = "";
  purchase_note: string | null = "";
  categories: any[] | null = [];
  tags: any[] | null = [];
  images: any[] | null = [];
  attributes: any[] | null = [];
  default_attributes: any[] | null = [];
  variations: any[] | null = [];
  grouped_products: any[] | null = [];
  menu_order: number | null = null;
  price_html = "";
  related_ids: any[] | null = [];
  meta_data: any[] | null = [];
  stock_status: string | null = "";
  has_options: boolean | null = null;
  post_password: string | null = "";
  _links: any[] | null = [];
}

export class OrderOfferStateModel {
  products: ProductModel[] = [];
  transportOptions: TransportSettingsModel[] = [];
  paymentMethods: string[] = [];
}

export class ClientModel {
  _id: string | null = null;
  firstName: string | null = "";
  lastName: string | null = "";
  CNP: string | null = "";
  address: AddressModel | null = {
    city: "",
    county: "",
    country: "",
    details: "",
    postcode: " ",
  };
  email: string | null = "";
  phone: string | null = "";
  ci: any;
  drivingLicense: File | null = null;
  drivingCategories: string[] | null = null;
  drivingLicenseIssuedDate: string | null = null;
  drivingLicenseExpirationDate: string | null = null;
}

export class ContactPersonModel {
  firstName: string | null = "";
  lastName: string | null = "";
  email: string | null = "";
  phone: string | null = "";
  static stringify(contact: ContactPersonModel | null | undefined) {
    if (!contact) return "";
    return (
      [contact.firstName, contact.lastName, contact.email, contact.phone]
        ?.filter(Boolean)
        .join(", ") || "-"
    );
  }
}

export class ExamsSetModel {
  _id?: string | undefined = undefined;
  name: string | undefined = "";
  examCategory: string | undefined = "";
  imageUrl: string | undefined = "";
  answeredQuestions: number | undefined = 0;
  totalQuestions: number | undefined = 0;
  correctAnswers: number | undefined = 0;
  productsIds?: string[] | undefined = [];
}

export class DayModel {
  name: string | null = "";
  value: number | null = null;
}
export class PeriodicityModel {
  name: string | null = "";
  nextContactDate: string | Date | null = "";
  noDays: number | null = null;
  week: number | null = null;
  day: DayModel | null = null;
}

export class AddressModel {
  city: string | null = "";
  county: string | null = "";
  country: string | null = "";
  details: string | null = "";
  postcode: string | null = "";
  static stringify(address: AddressModel | null | undefined) {
    if (!address) return "";
    return (
      [
        address.details,
        address.city,
        address.postcode,
        address.county,
        address.country,
      ]
        ?.filter(Boolean)
        .join(", ") || "-"
    );
  }
}

export class RoleModel {
  _id = null;
  name: string | null = "";
  priority: number | null = null;
  createdAt: string | null = "";
  updatedAt: string | null = "";
}

export class DocumentsModel {
  _id = null;
  name: string | null = "";
  document: string | null = null;
  documents: any[] = [];
  expirationDate: Date | null = new Date();
  documentTypeId: string | null = "";
  isTemplate = false;
}

export class Attachment {
  filename: string | null = "";
  path: string | null = "";
  cid: string | null = "";
  alt: string | null = "";
}
export class EmailTemplateModel {
  _id: string | null = null;
  emailTemplateName: string | null = "";
  html: any = "";
  statusId: string | null = null;
  subject: string | null = "";
  cc: string | null = "";
  attachments: Attachment[] = [];
}

export class ContactModel {
  _id: string | null = null;
  conversation: any;
  contactedViaEmail = false;
  contactedViaPhone = false;
  agent: UserModel | null = null;
  order: OrderModel | null = null;
  client: ClientModel = new ClientModel();
  observations: string | null = null;
  notes: NoteModel[] = [];
  status: string | null = null;
  createdAt: string | null = null;
  updatedAt: string | null = null;
}

export class TodaysContactsState {
  noTotalResults: number | null = 0;
  noTakenContacts = 0;
  noAvailableContacts = 0;
  noDelayedContacts = 0;
}

export class ConversationModel {
  _id: string | null = null;
  client: ClientModel | null = null;
  wa_id: string | null = null;
  potentialClientName: string | null = null;
  messages: MessageModel[] = [];
  lastRead: string | null = null;
  createdAt: string | null = null;
  updatedAt: string | null = null;
  deletedAt: string | null = null;
}

export class ChatState {
  chat: ConversationModel | null = null;
  messages: MessageModel[] = [];
  page = 0;
  templates: any[] = [];
}

export class InvoiceModel {
  cif: string | null = "";
  client: OblioClientModel | null = new OblioClientModel();
  issueDate: string | null = "";
  dueDate: string | null = "";
  seriesName: string | null = "";
  number: number | null = null;
  language: string | null = null;
  precision: number | null = null;
  currency: string | null = null;
  exchangeRate: number | null = null;
  products: OblioProductModel[] = [];
  issuerName: string | null = "";
  issuerId: string | null = "";
  noticeNumber: string | null = "";
  internalNote: string | null = "";
  deputyName: string | null = "";
  deputyIdentityCard: string | null = "";
  deputyAuto: boolean | null = false;
  selesAgent: string | null = "";
  mentions: string | null = "";
  sendEmail: boolean | null = false;
  workStation: string | null = "";
  disableAutoSeries: boolean | null = false;
  deliveryDate: string | null = "";
  collectDate: string | null = "";
  referenceDocument: ReferenceDocumentModel | null =
    new ReferenceDocumentModel();
  collect: CollectModel | null = new CollectModel();
  useStock: number | null = null;
}

export class OblioProductModel {
  name: string | null = "";
  code: string | null = "";
  description: string | null = "";
  price: number | null = null;
  measuringUnit: string | null = "";
  currency: string | null = "";
  exchangeRate: number | null = null;
  vatName: string | null = "";
  vatPercentage: number | null = null;
  vatIncluded: boolean | null = null;
  quantity: number | null = null;
  management: string | null = "";
  productType: string | null = "";
  nameTranslation: string | null = "";
  measuringUnitTranslation: string | null = "";
  save: boolean | null = null;
}

export class OblioClientModel {
  cif: string | null = "";
  name: string | null = "";
  rc: string | null = "";
  code: string | null = "";
  address: string | null = "";
  state: string | null = "";
  city: string | null = "";
  country: string | null = "";
  iban: string | null = "";
  bank: string | null = "";
  email: string | null = "";
  phone: string | null = "";
  contact: string | null = "";
  vatPayer: boolean | null = null;
  save: boolean | null = null;
  autocomplete: boolean | null = null;
}

export class ReferenceDocumentModel {
  type: string | null = "";
  number: number | null = null;
  seriesName: string | null = "";
  refund: boolean | null = null;
}

export class CollectModel {
  type: string | null = "";
  seriesName: string | null = "";
  documentNumber: number | null = null;
  value: number | null = null;
  issueDate: string | null = "";
  mentions: string | null = "";
}

export class WhatsAppBusinessAccountData {
  _id: string | null = null;
  name: string | null = "";
  whatsAppBusinessAccountId: string | null = "";
  phoneNumberId: string | null = "";
  phoneNumber: string | null = "";
  verifiedName: string | null = "";
  isPhoneNumberVerified: boolean | null = false;
}

export class OrderStatusState {
  orderStatusPerPage: any[] = [];
  orderStatusNumber: number | undefined = 0;
  page = 0;
  perPage: number | undefined = Config.rowsPerPage;
  search: string | null = null;
  order: string | null = SortOptions.asc;
  filter: string | null = null;
  preview: boolean | null = false;
  selectedRequest: any = {};
  loading: boolean | null = false;
}

export class WhatsAppTemplateState {
  templates: any[] = [];
  limit: number | null = Config.rowsPerPage;
  before: string | null = null;
  after: string | null = null;
  count: number | undefined = 0;
  page = 0;
  perPage: number | undefined = Config.rowsPerPage;
}

export class IssueBillingDocument {
  invoiceModel: InvoiceModel | null = null;
  checkedLinesIds: string[] = [];
  order: OrderModel | null = null;

  constructor(
    _model: InvoiceModel,
    _checkedLinesIds: string[],
    _order: OrderModel
  ) {
    this.invoiceModel = _model;
    this.checkedLinesIds = _checkedLinesIds;
    this.order = _order;
  }
}

export class RegisterWhatsAppPhoneNumberContextMode {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  handleNext: any = () => {};
  activeStep: number | null = 0;
}

export class LogModel {
  userName = "";
  method = "";
  table = "";
  createdAt: string | null = "";
  updatedAt: string | null = "";
  differences: any;
  object: any;
  database = "";
}

export class GenericTaskSubEntityModel {
  id: string | null = null;
  name: string | null = "";
  tag = "";
}
export class TaskPeriodicityModel extends GenericTaskSubEntityModel {
  nrOfDays = 0;
}

export class SelectionRangeModel {
  startDate: Date | undefined = new Date();
  endDate: Date | undefined = new Date();
  key = "selection";
}

export class AssignedUsersOptionsStateModal {
  checkAllUsers = false;
  option = 0;
}

export class TaskStatusModel extends GenericTaskSubEntityModel {
  color = "#000000";
  name = "";
  isEditable = true;
  deletedAt = null;
  createdAt = "";
  updatedAt = "";
}

export class AlertModel {
  _id?: string | undefined = undefined;
  name = "";
  property: string | null = null;
  rule: string | null = null;
  threshold: string | number | null = null;
  color = "#FFF";
  sendEmail = false;
}

export class AlertPerEntitiesModel {
  _id: string | undefined = undefined;
  modelType = "";
  model: string | null = null;
  alert: AlertModel = new AlertModel();
}

export class TaskModel {
  _id: string | undefined = undefined;
  text = "";
  description = "";
  status: TaskStatusModel = new TaskStatusModel();
  periodicity: TaskPeriodicityModel = new TaskPeriodicityModel();
  type: string | null = null;
  priority: string | null = null;
  progress: number | null = null;
  createdBy: UserModel = new UserModel();
  parent: TaskModel | null = null;
  start: string | null = null;
  end: string | null = null;
  finishDate: string | null = null;
  remarks: string | null = null;
  assignedUsers: UserModel[] = [];
  skipWeekend = false;
  isFlexible = false;
  delay: number | null = null;
  createdAt = "";
  updatedAt = "";
  deletedAt = "";
}

export class OrderModel {
  _id?: string | undefined = undefined;
  orderNumber?: string | null = null;
  status: OrderStatusModel | null = null;
  client_id: ClientModel | null = null;
  instructor_id: InstructorModel | null = null;
  vehicle_id?: VehicleModel | null = null;
  product: ProductModel | null = null;
  payed: string | null = null;
  date_completed: string | null = null;
  date_paid: string | null = null;
  documents: DocumentsModel[] = [];
}

export class ClassModel {
  _id = null;
  name: string | null = "";
  typeId: string | OrderTypeModel | null = "";
  workPointId: string | WorkPointModel | null = null;
}

export class HourModel {
  _id = null;
  date: string | null = null;
  startHour: string | null = null;
  endHour: Date | string | null = null;
  startKm: string | null = null;
  endKm: string | null = null;
  vehicleId: string | VehicleModel | null = null;
  instructorId: string | InstructorModel | null = null;
}
export class AccountModel {
  _id = undefined;
  name: string | undefined = "";
  iban: string | null = "";
  balance: number | null = null;
  isDeleted: boolean | null = false;
}

export class ExamSetModel {
  _id?: string | undefined = undefined;
  name: string | undefined = "";
  imageUrl: string | null = "";
  productId: string | null = "";
}

// ExamQuestionModel for Exam Questions Table and Form
export interface ExamAnswerModel {
  text: string;
  isCorrect: boolean;
}

export interface ExamQuestionModel {
  _id?: string;
  examSetId: string;
  questionText: string;
  imageUrl?: string;
  answers: ExamAnswerModel[];
  explanation?: string;
}

export class BookModel {
  _id?: string | undefined = undefined;
  name: string | undefined = "";
  workPointId: string | WorkPointModel | null = null;
  maxPerStudent: number | null = null;
  alertThreshold: number | null = null;
  price: number | null = null;
  quantity: number | null = null;
}

/**
 * Creates a Yup schema that accepts either a string (ID) or an object matching the given schema.
 * @param label - Optional label for error messages
 * @param objectSchema - A Yup object schema to validate against if the value is an object
 * @returns Yup schema
 */
export function objectOrId(
  objectSchema?: yup.ObjectSchema<any>,
  required = false
) {
  return yup.lazy((value) => {
    if (typeof value === "string") {
      return yup.string().required(Vocabulary.requiredField);
    }

    if (typeof value === "object" && value !== null) {
      return (
        objectSchema ??
        yup.object({
          _id: yup.string().required(Vocabulary.requiredField),
        })
      );
    }

    return required
      ? yup.string().required(Vocabulary.requiredField)
      : yup.mixed().nullable().notRequired();
  });
}

export const BillingValidationSchema = yup.object().shape({
  address_1: yup.string().nullable(),
  address_2: yup.string().nullable(),
  city: yup.string().nullable(),
  company: yup.string().nullable(),
  country: yup.string().nullable(),
  email: yup.string().nullable(),
  first_name: yup.string().nullable(),
  last_name: yup.string().nullable(),
  phone: yup.string().nullable().matches(Config.phoneRegExp, {
    message: Vocabulary.phoneValidation,
    excludeEmptyString: true,
  }),
  postcode: yup.string().nullable(),
  state: yup.string().nullable(),
});

export const AddressValidationSchema = yup.object().shape({
  city: yup.string().nullable(),
  county: yup.mixed().nullable(),
  country: yup.string().nullable(),
  details: yup.string().nullable(),
  postcode: yup.string().nullable(),
});

export const ContactPersonValidationSchema = yup
  .object()
  .shape({
    email: yup.string(),
    firstName: yup.string(),
    lastName: yup.string(),
    name: yup.string().nullable(),
    phone: yup.string(),
  })
  .nullable();

export const OrderClientValidationSchema = yup
  .object()
  .shape({
    address: AddressValidationSchema,
    category: yup.array().nullable(),
    contactPerson: ContactPersonValidationSchema,
    fiscalCode: yup.string().nullable(),
    iban: yup.string().nullable(),
    name: yup.string().nullable(),
    periodicity: yup.array(),
    phone: yup.string(),
    drivingCategories: yup
      .array()
      .of(
        yup.object().shape({
          category: yup.string().nullable(),
          issueDate: yup.string().nullable(),
          expirationDate: yup.string().nullable(),
        })
      )
      .nullable(),
  })
  .nullable();

export const OrderNoteValidationSchema = yup.object().shape({
  agent: yup.mixed().nullable(),
  client: yup.mixed().nullable(),
  text: yup.string().nullable(),
  type: yup.string(),
  visibility: yup.string().nullable(),
});

export const ShippingValidationSchema = yup
  .object()
  .shape({
    address_1: yup.string().nullable(),
    address_2: yup.string().nullable(),
    city: yup.string().nullable(),
    company: yup.string().nullable(),
    country: yup.string().nullable(),
    first_name: yup.string().nullable(),
    last_name: yup.string().nullable(),
    postcode: yup.string().nullable(),
    state: yup.string().nullable(),
  })
  .nullable();

export const ShippingMethodValidationSchema = yup
  .object()
  .shape({
    name: yup.string(),
    value: yup.number(),
    isDefault: yup.boolean(),
  })
  .nullable()
  .default(null);

export const BillingDocumentValidationSchema = yup
  .object()
  .shape({
    type: yup.string().nullable(),
    issueDate: yup.string().nullable(),
    seriesName: yup.string().nullable(),
    number: yup.string().nullable(),
    link: yup.string().nullable(),
    edit: yup.string().nullable(),
    issuerName: yup.string().nullable(),
  })
  .nullable();

export const ContactSettingsValidationSchema = yup.object().shape({
  _id: yup.string(),
  value: yup.object().shape({
    shouldRenderOldContacts: yup.boolean().default(false),
    contactDeletionThreshold: yup.number().nullable().default(30),
  }),
});

export const ClientSettingsValidationSchema = yup.object().shape({
  _id: yup.string(),
  value: yup.object().shape({
    shouldSendEmailToAllClients: yup
      .boolean()
      .default(false)
      .required(Vocabulary.requiredField),
  }),
});

export const MessageTextValidationSchema = yup
  .object()
  .shape({
    body: yup.string().required(Vocabulary.requiredField),
    preview_url: yup
      .boolean()
      .required(Vocabulary.requiredField)
      .default(false),
  })
  .required(Vocabulary.requiredField);

export const MessageTemplateValidationSchema = yup
  .object()
  .when("type", (type: any, schema: any) => {
    return type[0] === EWhatsAppMessageType.TEMPLATE
      ? schema
          .shape({
            name: yup.string().required(Vocabulary.requiredField),
            language: yup.object().shape({
              code: yup.string().required(Vocabulary.requiredField),
            }),
          })
          .required(Vocabulary.requiredField)
      : schema.nullable().notRequired();
  });

export const MessageComponentsValidationSchema = yup
  .array()
  .when("type", (type: any, schema: any) => {
    return type[0] === EWhatsAppMessageType.TEMPLATE
      ? schema
          .of(
            yup.object().shape({
              type: yup.string().required(Vocabulary.requiredField),
              parameters: yup.array().required(Vocabulary.requiredField),
            })
          )
          .required(Vocabulary.requiredField)
      : schema.nullable().notRequired();
  });

export const MessageValidationSchema = yup
  .object()
  .shape({
    messaging_product: yup
      .string()
      .required(Vocabulary.requiredField)
      .default("whatsapp"),
    recipient_type: yup
      .string()
      .required(Vocabulary.requiredField)
      .default("individual"),
    to: yup.string().required(Vocabulary.requiredField),
    type: yup
      .string()
      .required(Vocabulary.requiredField)
      .default(EWhatsAppMessageType.TEXT),
    text: MessageTextValidationSchema,
    context: yup.object().shape({
      message_id: yup.string().nullable(),
    }),
    template: MessageTemplateValidationSchema,
    components: MessageComponentsValidationSchema,
  })
  .required(Vocabulary.requiredField);

export const MediaMessageValidationSchema = yup.object().shape({
  file: yup.mixed().required(Vocabulary.requiredField),
  caption: yup.string().nullable(),
});

export const NoteValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  type: yup.string(),
  client: yup.mixed().nullable(),
  agent: yup.mixed().nullable(),
  text: yup.string().required(Vocabulary.requiredField),
  visibility: yup.boolean().default(false),
  details: yup.string(),
});

export const clientCategoryValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
});

export const CompanyFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  CUI: yup.string().required(Vocabulary.requiredField),
  name: yup.string().required(Vocabulary.requiredField),
  phoneNumber: yup
    .string()
    .matches(
      /^(\+?\d{1,3}[- ]?)?\d{10}$/,
      "Phone number must be valid and contain 10 digits"
    )
    .required(Vocabulary.requiredField),
  email: yup
    .string()
    .email(Vocabulary.emailValidation)
    .required(Vocabulary.requiredField),
  visible: yup.boolean().required(Vocabulary.requiredField).default(true),
  address: AddressValidationSchema,
});

export const WorkPointFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  phoneNumber: yup
    .string()
    .matches(
      /^(\+?\d{1,3}[- ]?)?\d{10}$/,
      "Phone number must be valid and contain 10 digits"
    )
    .required(Vocabulary.requiredField),
  email: yup
    .string()
    .email(Vocabulary.emailValidation)
    .required(Vocabulary.requiredField),
  schoolName: yup.string().nullable(),
  serialNumber: yup.string().nullable(),
  oblioSerialNumber: yup.string().nullable(),
  number: yup.string().nullable(),
  administrator: yup.string().nullable(),
  director: yup.string().nullable(),
  visible: yup.boolean().required(Vocabulary.requiredField).default(true),
  isMain: yup.boolean().required(Vocabulary.requiredField).default(false),
  address: AddressValidationSchema,
  automaticCategoryPriceIncrease: yup.number().default(0),
  companyId: yup.string().nullable().optional(),
});

export const ClientValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  firstName: yup.string().required(Vocabulary.requiredField),
  lastName: yup.string().required(Vocabulary.requiredField),
  email: yup.string().email(Vocabulary.emailValidation),
  phone: yup
    .string()
    .required(Vocabulary.requiredField)
    .matches(/\(?([0-9]{2})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/, ""),
  CNP: yup.string().nullable(),
  address: AddressValidationSchema,
  ci: yup.mixed().nullable(),
  workPointId: objectOrId(WorkPointFormValidationSchema, true),
});

export const TaskStatusValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  color: yup.string().required(Vocabulary.requiredField),
  tag: yup.string().required(Vocabulary.requiredField),
});

export const TaskPeriodicityValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  nrOfDays: yup.number().required(Vocabulary.requiredField),
  tag: yup.string().required(Vocabulary.requiredField),
});

export const SubtaskValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  text: yup.string().required(Vocabulary.requiredField),
  description: yup.string().required(Vocabulary.requiredField),
  status: TaskStatusValidationSchema.required(Vocabulary.requiredField).default(
    null
  ),
  parent: yup.mixed().nullable(),
  createdBy: yup.mixed().nullable(),
});

export const TaskValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  text: yup.string().required(Vocabulary.requiredField),
  description: yup.string().nullable(),
  status: TaskStatusValidationSchema.required(Vocabulary.requiredField),
  periodicity: TaskPeriodicityValidationSchema,
  type: yup.string().required(Vocabulary.requiredField),
  priority: yup.string().required(Vocabulary.requiredField),
  progress: yup.number().nullable(),
  createdBy: yup.mixed().nullable(),
  parent: yup.mixed().nullable(),
  assignedUsers: yup.array().of(yup.mixed()),
  start: yup.string().required(Vocabulary.requiredField),
  end: yup.string().required(Vocabulary.requiredField),
  finishDate: yup.string().nullable(),
  remarks: yup.string().nullable(),
  skipWeekend: yup.boolean().nullable(),
  isFlexible: yup.boolean().nullable().default(true),
});

export const ClientsAutocompleteValidationSchema = yup
  .object()
  .shape({
    clientId: yup.string().required(Vocabulary.requiredField),
  })
  .required();
export const ContactEmailValidationSchema = yup.object().shape({
  emailTemplate: yup.mixed().required(Vocabulary.requiredField),
  emailContent: yup.string().required(Vocabulary.requiredField),
});

export const FiltersValidationSchema = yup.object().shape({
  start: yup.string().required(Vocabulary.requiredField),
  end: yup.string().required(Vocabulary.requiredField),
});

export const OrderSettingsFormValidationSchema = yup.object().shape({
  _id: yup.string(),
  value: yup.object().shape({
    startOrderNumber: yup.number(),
    currentOrderNumber: yup.number(),
    paymentMethods: yup.array().of(
      yup.object().shape({
        name: yup.string(),
        shouldDelete: yup.boolean(),
      })
    ),
  }),
});

export const TransportSettingsFormValidationSchema = yup.object().shape({
  transportsMethods: yup.array().of(
    yup.object().shape({
      name: yup.string().required(Vocabulary.requiredField),
      value: yup.string().required(Vocabulary.requiredField),
      isDefault: yup.boolean(),
      showEdit: yup.boolean(),
      confirmDelete: yup.boolean(),
    })
  ),
});

export const WhatsAppSettingsValidationSchema = yup.object().shape({
  _id: yup.string().required(Vocabulary.requiredField),
  whatsAppBusinessAccountId: yup.string().required(Vocabulary.requiredField),
  name: yup.string().required(Vocabulary.requiredField),
  phoneNumberId: yup.string().nullable(),
  phoneNumber: yup.string().nullable(),
  verifiedName: yup.string().nullable(),
  whatsAppTemplateAssociatedWithOrderOffer: yup.mixed().nullable(),
});

export const PhoneNumberRegistrationSchema = yup.object().shape({
  cc: yup.string().required(Vocabulary.requiredField).default("+40"),
  phone_number: yup.string().required(Vocabulary.requiredField),
  verified_name: yup.string().required(Vocabulary.requiredField),
});

export const TwoFactorAuthenticationSetupSchema = yup.object().shape({
  pin: yup.string().required(Vocabulary.requiredField),
});

export const VerifyCodeConfirmationSchema = yup.object().shape({
  code: yup.string().required(Vocabulary.requiredField),
});

export const WhatsAppTemplateValidationSchema: any = yup.object().shape({
  id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  category: yup.string().required().default(EWhatsAppTemplateCategory.UTILITY),
  allow_category_change: yup.boolean().nullable().default(true),
  language: yup.string().default("ro").required(Vocabulary.requiredField),
  components: yup.array().of(
    yup.object().shape({
      type: yup.string().required(Vocabulary.requiredField),
      format: yup.string().when("type", (type: any, schema: any) => {
        return type[0] === EWhatsAppComponentsTypes.HEADER
          ? schema.required(Vocabulary.requiredField)
          : schema.nullable().notRequired();
      }),
      text: yup.string().when(["type", "format"], (data: any, schema: any) => {
        if (data[0] === EWhatsAppComponentsTypes.BODY)
          return schema.required(Vocabulary.requiredField);
        else if (
          data.length > 1 &&
          data[0] === EWhatsAppComponentsTypes.HEADER &&
          data[1] === "TEXT"
        )
          return schema.required(Vocabulary.requiredField);
        return schema.nullable().notRequired();
      }),
      example: yup
        .object()
        .when(["type", "text", "format"], (data: any, schema: any) => {
          if (data[0] === EWhatsAppComponentsTypes.HEADER) {
            switch (data[2]) {
              case EHeaderTemplateMenuOptions.TEXT:
                return schema.shape({
                  header_text: yup
                    .array()
                    .of(yup.string().required(Vocabulary.requiredField)),
                });
              case EHeaderTemplateMenuOptions.IMAGE:
              case EHeaderTemplateMenuOptions.VIDEO:
              case EHeaderTemplateMenuOptions.DOCUMENT:
                return schema.shape({
                  header_handle: yup
                    .array()
                    .of(yup.string().required(Vocabulary.requiredField)),
                });
              default:
                return schema.nullable().notRequired();
            }
          } else if (data[0] === EWhatsAppComponentsTypes.BODY) {
            //check if data[1] contains tags like {{nr}} (regex)
            const regex = /{{\w+}}/g;
            const found = data[1].match(regex);
            if (found)
              return schema.shape({
                body_text: yup
                  .array()
                  .of(
                    yup
                      .array()
                      .of(yup.string().required(Vocabulary.requiredField))
                  ),
              });
          }
          return schema.nullable().notRequired();
        }),
      buttons: yup.array().when("type", (type: any, schema: any) => {
        return type[0] === EWhatsAppComponentsTypes.BUTTONS
          ? schema
              .of(
                yup
                  .object()
                  .shape({
                    type: yup.string().required(Vocabulary.requiredField),
                    text: yup.string().required(Vocabulary.requiredField),
                    phone_number: yup
                      .string()
                      .when("type", (type: any, schema: any) => {
                        return type === EWhatsAppTemplateButtonType.PHONE_NUMBER
                          ? schema.required(Vocabulary.requiredField)
                          : schema.nullable().notRequired();
                      }),
                    url: yup.string().when("type", (type: any, schema: any) => {
                      return type === EWhatsAppTemplateButtonType.URL
                        ? schema.required(Vocabulary.requiredField)
                        : schema.nullable().notRequired();
                    }),
                  })
                  .required(Vocabulary.requiredField)
              )
              .required(Vocabulary.requiredField)
          : schema.nullable().notRequired();
      }),
    })
  ),
});

export const CollectInvoiceValidationSchema = yup
  .object()
  .shape({
    type: yup.string().nullable(),
    seriesName: yup.string().nullable(),
    documentNumber: yup.number().nullable(),
    value: yup.number().nullable(),
    issueDate: yup.string().nullable(),
    mentions: yup.string().nullable(),
  })
  .nullable();

export const InvoicePanelValidationSchema = yup.object().shape({
  type: yup.string().nullable(),
  issueDate: yup
    .string()
    .required(Vocabulary.requiredField)
    .default(moment().format(Config.momentUSDateFormat)),
  dueDate: yup.string().nullable(),
  seriesName: yup.string().nullable(),
  number: yup.string().nullable(),
  link: yup.string().nullable(),
  products: yup.array().of(
    yup.object().shape({
      name: yup.string().nullable(),
      price: yup.number().nullable(),
      quantity: yup.number().nullable(),
      vatPercentage: yup.number().nullable(),
      vatIncluded: yup.number().nullable(),
      productType: yup.string().nullable().default(Vocabulary.goods),
      management: yup.string().nullable(),
      measuringUnit: yup.string().nullable(),
      discount: yup.string().nullable(),
      discountType: yup.string().nullable(),
    })
  ),
  client: yup.object().shape({
    cif: yup.string().nullable(),
    name: yup.string().required(Vocabulary.requiredField),
    rc: yup.string().nullable(),
    address: yup.string().nullable(),
    state: yup.string().nullable(),
    code: yup.string().nullable(),
    city: yup.string().nullable(),
    country: yup.string().nullable(),
    phone: yup.string().nullable(),
    email: yup.string().nullable(),
    iban: yup.string().nullable(),
    bank: yup.string().nullable(),
    contact: yup.string().nullable(),
  }),
  issuerName: yup.string().required(Vocabulary.requiredField),
  issuerId: yup.string().nullable(),
  noticeNumber: yup.string().nullable(),
  internalNote: yup.string().nullable(),
  deputyName: yup.string().nullable(),
  deputyIdentityCard: yup.string().nullable(),
  selesAgent: yup.string().nullable(),
  mentions: yup.string().nullable(),
  referenceDocument: yup
    .object()
    .shape({
      type: yup.string().nullable(),
      seriesName: yup.string().nullable(),
      number: yup.string().nullable(),
      refund: yup.number().nullable(),
    })
    .nullable(),
  collect: CollectInvoiceValidationSchema,
  workStation: yup.string().nullable(),
});

export const OneAlertValidationSchema = yup.object().shape({
  name: yup.string().required(Vocabulary.requiredField),
  property: yup.string().required(Vocabulary.requiredField),
  rule: yup.string().required(Vocabulary.requiredField),
  roles: yup
    .array()
    .required(Vocabulary.requiredField)
    .min(1, Vocabulary.requiredField),
  threshold: yup.string().required(Vocabulary.requiredField),
  color: yup.string().required(Vocabulary.requiredField),
  sendEmail: yup.boolean().required(Vocabulary.requiredField),
});

export const CustomFilterValidationSchema = yup.object().shape({
  property: yup.string().required(Vocabulary.requiredField),
  rule: yup.string().required(Vocabulary.requiredField),
  threshold: yup.string().required(Vocabulary.requiredField),
});

export const DocumentsFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  document: yup.mixed(),
  //.test("file", Vocabulary.requiredField, (value) => value instanceof File),
  expirationDate: yup.date().required(Vocabulary.requiredField),
});

export const UserDocumentIdsSchema = yup
  .object({
    psychological: objectOrId(DocumentsFormValidationSchema, false),
    medical: objectOrId(DocumentsFormValidationSchema, false),
    criminal: objectOrId(DocumentsFormValidationSchema, false),
  })
  .nullable()
  .default(null);

export const UserFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  lastName: yup.string().required(Vocabulary.requiredField),
  firstName: yup.string().required(Vocabulary.requiredField),
  username: yup.string().required(Vocabulary.requiredField),
  email: yup
    .string()
    .email(Vocabulary.emailValidation)
    .required(Vocabulary.requiredField),
  workPoint_id: yup.mixed().test("is-valid-id", "", (value) => {
    // Allow string, or object with _id
    return (
      typeof value === "string" || // Allow string
      (typeof value === "object" && value !== null && "_id" in value) // Allow object with _id
    );
  }),
  password: yup.string().when(["_id"], (_id: any, schema: any) => {
    return _id[0] !== null && _id[0] !== undefined
      ? schema.nullable().notRequired()
      : schema.required(Vocabulary.requiredField);
  }),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), " "], Vocabulary.confirmMessage)
    .when(["_id"], (_id: any, schema: any) => {
      return _id[0] !== null && _id[0] !== undefined
        ? schema.nullable().notRequired()
        : schema.required(Vocabulary.requiredField);
    }),
  roleIds: yup
    .array()
    .required(Vocabulary.requiredField)
    .min(1, Vocabulary.requiredField),
  documentIds: UserDocumentIdsSchema,
});

export const VehicleFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  brand: yup.string().required(Vocabulary.requiredField),
  model: yup.string().required(Vocabulary.requiredField),
  modelDate: yup.string(),
  color: yup.string().required(Vocabulary.requiredField),
  vehicleNumber: yup
    .string()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .matches(/^[A-Z]{2}-\d{2,3}-[A-Z]{3}$/, Vocabulary.vehicleNumberFormat), //either null, or respecting a certain format
  document_ids: yup.array().of(DocumentsFormValidationSchema),
  revisionIds: yup.array(),
  isActive: yup.boolean().required(Vocabulary.requiredField).default(true),
  automata: yup.boolean().required(Vocabulary.requiredField).default(false),
  chassis: yup
    .string()
    .required(Vocabulary.requiredField)
    .matches(/^[A-HJ-NPR-Z0-9]{17}$/, Vocabulary.invalidVINFormat),
  workPointId: yup
    .mixed()
    .nullable() // Allow null values
    .notRequired() // Explicitly mark as not required
    .test("is-valid-id", "", (value) => {
      // Treat empty string as null
      if (value === "") {
        value = null;
      }
      // Allow null, string, or object with _id
      return (
        !value || // Allow null value
        typeof value === "string" || // Allow string
        (typeof value === "object" && value !== null && "_id" in value) // Allow object with _id
      );
    }),
});

export const InstructorFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  user_id: objectOrId(UserFormValidationSchema, true),
  vehicle_ids: yup.array().required(Vocabulary.requiredField),
  document_ids: yup
    .array()
    .of(objectOrId(DocumentsFormValidationSchema, false)),
  documentIds: UserDocumentIdsSchema,
  canScheduleHours: yup.boolean().nullable().default(false),
});

export const ProductFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  isCertificate: yup
    .boolean()
    .required(Vocabulary.requiredField)
    .default(false),
  automata: yup.boolean().required(Vocabulary.requiredField).default(false),
  visibleForOnlineEnrollment: yup
    .boolean()
    .required(Vocabulary.requiredField)
    .default(false),
  defaultDrivingHours: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === "" || originalValue === null ? undefined : value;
    })
    .nullable(),
  monitorThresholdMonths: yup
    .number()
    .required(Vocabulary.requiredField)
    .default(Config.defaultMonitorThresholdMonths),
  examCategory: yup.string().nullable(),
  documentTypes: yup.array().of(yup.string()).nullable().default([]),
  price: yup
    .number()
    .transform((value, originalValue) => {
      return originalValue === "" || originalValue === null ? undefined : value;
    })
    .nullable(),
});

export const OrderStatusFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  slug: yup.string(),
  isDefault: yup.boolean().required(Vocabulary.requiredField).default(false),
  color: yup.string().required(Vocabulary.requiredField).default("#FFF"),
  sortNumber: yup.number(),
});

export const ClientSchema = yup.object().shape({
  _id: yup.string().nullable(),
  firstName: yup.string().required(Vocabulary.requiredField),
  lastName: yup.string().required(Vocabulary.requiredField),
  email: yup.string().email(Vocabulary.emailValidation),
  phone: yup
    .string()
    .required(Vocabulary.requiredField)
    .matches(/\(?([0-9]{2})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/, ""),
  CNP: yup
    .string()
    .required(Vocabulary.requiredField)
    .matches(/^\d{13}$/, Vocabulary.invalidCNP),
  address: AddressValidationSchema,
  ci: yup.mixed().nullable(),
  drivingLicense: yup.mixed().nullable(),
  documents: yup.array(),
  workPoint: yup.string().nullable(),
  gender: yup.string().nullable(),
  ciSerialNumber: yup.string().nullable(),
  ciNumber: yup.string().nullable(),
  ciIssuedBy: yup.string().nullable(),
  ciIssuedDate: yup.string().nullable(),
  ciExpirationDate: yup.string().nullable(),
  drivingLicenseIssuedDate: yup.string().nullable(),
  drivingLicenseExpirationDate: yup.string().nullable(),
  drivingCategories: yup
    .array()
    .of(
      yup.object().shape({
        category: yup.string().nullable(),
        issueDate: yup.string().nullable(),
        expirationDate: yup.string().nullable(),
      })
    )
    .nullable(),
});

export const RecommendationValidationSchema = yup.object().shape({
  user_id: yup.string().nullable(),
  recommendationValue: yup.number().nullable(),
  clientIdNumber: yup.string().nullable(),
  paymentMethod: yup.string().nullable(),
});

export const ClientDocumentValidationSchema = yup.object().shape({
  psychological: yup
    .object()
    .shape({
      documentId: yup.string().nullable(),
    })
    .nullable(),

  medical: yup
    .object()
    .shape({
      documentId: yup.string().nullable(),
    })
    .nullable(),

  criminal: yup
    .object()
    .shape({
      documentId: yup.string().nullable(),
    })
    .nullable(),
});

export const OrderTypeFormValidationSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
});

export const OrderValidationSchema = yup.object().shape({
  _id: yup.string(),
  status: yup.string().when(["_id"], (_id: any, schema: any) => {
    return _id[0] !== null && _id[0] !== undefined
      ? OrderStatusFormValidationSchema
      : schema.nullable().notRequired();
  }),
  client_id: ClientSchema,
  instructor_id: yup.string().nullable(),
  product: ProductFormValidationSchema,
  payed: yup.string().nullable(),
  date_completed: yup.date(),
  date_paid: yup.date(),
  recommendation_id: yup
    .object()
    .shape({
      ...RecommendationValidationSchema.fields,
    })
    .nullable(),
  document: ClientDocumentValidationSchema,
  address: AddressValidationSchema,
  createdBy: yup.string().nullable(),
  orderType: objectOrId(OrderTypeFormValidationSchema),
});

export const ClassValidationSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
  typeId: objectOrId(OrderTypeFormValidationSchema),
  workPointId: objectOrId(WorkPointFormValidationSchema),
  isActive: yup.boolean().required(Vocabulary.requiredField).default(true),
});

export const HoursValidationSchema = yup.object().shape({
  _id: yup.string(),
  date: yup
    .string()
    .required(Vocabulary.requiredField)
    .test("is-future-date", Vocabulary.pastDateNotAllowed, function (value) {
      if (!value) return true;
      const selectedDate = moment(value).startOf("day");
      const yesterday = moment().subtract(1, "days").startOf("day");
      return selectedDate.isSameOrAfter(yesterday);
    })
    .test(
      "is-not-beyond-one-year",
      Vocabulary.futureDateWithinYearNotAllowed,
      function (value) {
        if (!value) return true;
        const selectedDate = moment(value).startOf("day");
        const maxDate = moment().add(1, "year").startOf("day");
        return selectedDate.isSameOrBefore(maxDate);
      }
    ),
  startHour: yup.string().required(Vocabulary.requiredField),

  endHour:
    yup.date().required(Vocabulary.requiredField) ||
    yup.string().required(Vocabulary.requiredField),
  startKm: yup.string().nullable(),
  endKm: yup
    .string()
    .nullable()
    .test("is-greater", Vocabulary.endKmValidation, function (value) {
      const { startKm } = this.parent;
      if (!value || !startKm) return true; // skip if empty, 'required' already handles that
      return Number(value) >= Number(startKm);
    }),
  instructorId: yup.lazy((value) => {
    if (typeof value === "string") {
      return yup.string().required(Vocabulary.requiredField);
    }
    return yup.mixed().nullable();
  }),
  vehicleId: yup.lazy((value) => {
    if (typeof value === "string") {
      return yup.string().nullable();
    }
    return yup.mixed().nullable();
  }),
  productIds: yup.array().nullable(),
});

export const ExamHoursValidationSchema = yup.object().shape({
  _id: yup.string(),
  date: yup.string().required(Vocabulary.requiredField),
  startHour: yup.string().required(Vocabulary.requiredField),
  endHour:
    yup.date().required(Vocabulary.requiredField) ||
    yup.string().required(Vocabulary.requiredField),
  instructorId: objectOrId(InstructorFormValidationSchema, true),
  vehicleId: objectOrId(VehicleFormValidationSchema, true),
});

export const TransactionValidationSchema = yup.object().shape({
  _id: yup.string(),
  amount: yup.number().required(Vocabulary.requiredField),
  paymentMethod: yup.string().nullable(),
  description: yup.string().required(Vocabulary.requiredField),
});

export class SupplimentaryHoursFormDefaultState {
  nrOfHours: string | number | null = null;
  price: string | number | null = null;
  paymentMethod: string = PaymentMethods.CASH;
}

export const AccountSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
  iban: yup.string().nullable(),
  balance: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
});

export const SalaryFormSchema = yup.object().shape({
  _id: yup.string(),
  paymentMethod: yup.string().required(Vocabulary.requiredField),
  isRefund: yup.boolean().required(Vocabulary.requiredField).default(false),
  instructorId: objectOrId(InstructorFormValidationSchema, false),
  amount: yup.number().required(Vocabulary.requiredField),
  account: objectOrId(AccountSchema, true),
  description: yup.string().required(Vocabulary.requiredField),
  clientId: objectOrId(ClientValidationSchema, false),
  vehicleId: objectOrId(VehicleFormValidationSchema, false),
  userId: objectOrId(UserFormValidationSchema, false),
  orderId: yup.string().nullable(),
});

export const WithdrawMoneySchema = yup.object().shape({
  amount: yup.number().required(Vocabulary.requiredField),
  accountId: objectOrId(AccountSchema, true),
  description: yup.string().required(Vocabulary.requiredField),
});

export class CourseModel {
  _id: string | null = null;
  name: string | null = "";
  sortNumber: number | null = 0;
  productsIds: ProductsModel[] = [];
}

export class CourseState {
  coursesPerPage: any[] = [];
  coursesNumber: number | undefined = 0;
  page = 0;
  perPage: number | undefined = Config.rowsPerPage;
  search: string | null = null;
  order: string | null = SortOptions.asc;
  filter: string | null = null;
  preview: boolean | null = false;
  selectedRequest: any = {};
  loading: boolean | null = false;
}

export const CourseValidationSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
  sortNumber: yup.number().required(Vocabulary.requiredField).default(0),
  products: yup.array().of(yup.object()),
});

const fileValidation = yup.lazy((value) => {
  if (Array.isArray(value)) {
    return yup
      .array()
      .length(1)
      .of(
        yup
          .mixed()
          .test("is-file", "Must be a File", (v) => v instanceof File)
          .required("File is required")
      )
      .required("File array is required");
  }

  return yup.string().nullable();
});

// Videos schema
export const VideoValidationSchema = yup.object().shape({
  iframe: yup.string().required(Vocabulary.requiredField),
});

export const ModuleValidationSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
  mainImageId: fileValidation,
  sortNumber: yup.number().required(Vocabulary.requiredField).default(0),
  courseId: objectOrId(CourseValidationSchema, false),
  documentIds: yup.array(),
  videos: yup
    .array()
    .of(VideoValidationSchema)
    .min(0, Vocabulary.requiredField),
});

export const ExamSetValidationSchema = yup.object().shape({
  name: yup.string().required(Vocabulary.requiredField),
  imageUrl: fileValidation,
  productIds: yup.array().of(objectOrId(ProductFormValidationSchema, true)),
  questionsInExam: yup.number().nullable().default(0),
});

// Validation schema for answers
export const ExamAnswerValidationSchema = yup.object().shape({
  text: yup.string().required(Vocabulary.requiredField),
  isCorrect: yup.boolean().default(false),
});

export const ExamQuestionValidationSchema = yup.object().shape({
  examSetId: yup.string().required(Vocabulary.requiredField),
  questionText: yup.string().required(Vocabulary.requiredField),
  imageUrl: yup.string().nullable(),
  answers: yup
    .array()
    .of(ExamAnswerValidationSchema)
    .min(1, Vocabulary.requiredField),
  explanation: yup.string().nullable(),
});

export const BookSchema = yup.object().shape({
  _id: yup.string(),
  name: yup.string().required(Vocabulary.requiredField),
  workPointId: objectOrId(WorkPointFormValidationSchema),
  maxPerStudent: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField),
  alertThreshold: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField),
  price: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField),
  quantity: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField),
});

export const SellBookSchema = yup.object().shape({
  bookId: objectOrId(BookSchema, true),
  quantity: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField),
  clientId: objectOrId(ClientValidationSchema, false),
  paymentMethod: yup.string().required(Vocabulary.requiredField),
});

export const CertificateExamValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  examDate: yup.date().required(Vocabulary.requiredField),
  workPointId: objectOrId(WorkPointFormValidationSchema, true),
});

export const SubscriptionFormValidationSchema = yup.object().shape({
  _id: yup.string().nullable(),
  name: yup.string().required(Vocabulary.requiredField),
  description: yup.string().nullable(),
  price: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField)
    .min(0, "Prețul trebuie să fie mai mare decât 0"),
  durationInDays: yup
    .number()
    .typeError(Vocabulary.requiredField)
    .required(Vocabulary.requiredField)
    .positive("Durata trebuie să fie mai mare decât 0"),
  benefits: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required(Vocabulary.requiredField),
      })
    )
    .min(1, Vocabulary.minimOneBenefit),
  isActive: yup.boolean().default(true),
});

export class OnlineLessonModel {
  _id: string | null = null;
  title: string | null = "";
  startDate: string | null = null;
  instructorId: string | null = null;
  productIds: string[] = [];
  targetScope = "specific";
  isRepeat = false;
  repeatIntervalDays: number | null = null;
  numberOfRepetitions: number | null = null;
}
